import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { routes } from './app.routes';
import { ApiInterceptor } from './api-interceptor';
import { CacheInterceptor } from './interceptors/cache-interceptor';
import { TimeoutInterceptor, DEFAULT_TIMEOUT } from './interceptors/timeout-interceptor';
import { ApiModule, Configuration } from '../api';
import { environment } from '../environments/environment';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      ApiModule,
      MatDialogModule,
      MatSnackBarModule
    ),
    {
      provide: Configuration,
      useFactory: () =>
        new Configuration({
          basePath: environment.apiAddress,
        }),
    },
    ApiInterceptor,
    CacheInterceptor,
    { provide: HTTP_INTERCEPTORS, useExisting: ApiInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useExisting: CacheInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true },
    { provide: DEFAULT_TIMEOUT, useValue: 600000 },
    provideCharts(withDefaultRegisterables())
  ]
};
